import { mapService } from "./mapService";
import { fromLonLat } from "ol/proj";

class MapCustomControlsService {

    zoomIn() {
        console.log("[MapCustomControlsService] zoomIn - Aumentando zoom");
        const map = mapService.get();
        if (!map) {
            console.error("[MapCustomControlsService] zoomIn - No hay mapa disponible");
            return;
        }
        const view = map.getView();
        const newZoom = view.getZoom() + 1;
        view.animate({ zoom: newZoom, duration: 150 });
        console.log(`[MapCustomControlsService] zoomIn - Nuevo zoom: ${newZoom}`);
    }

    zoomOut() {
        console.log("[MapCustomControlsService] zoomOut - Disminuyendo zoom");
        const map = mapService.get();
        if (!map) {
            console.error("[MapCustomControlsService] zoomOut - No hay mapa disponible");
            return;
        }
        const view = map.getView();
        const newZoom = view.getZoom() - 1;
        view.animate({ zoom: newZoom, duration: 150 });
        console.log(`[MapCustomControlsService] zoomOut - Nuevo zoom: ${newZoom}`);
    }

    resetView() {
        console.log("[MapCustomControlsService] resetView - Volviendo a vista inicial");
        const map = mapService.get();
        if (!map) {
            console.error("[MapCustomControlsService] resetView - No hay mapa disponible");
            return;
        }
        map.getView().animate({
            center: mapService.initialCenter,
            zoom: mapService.initialZoom,
            duration: 400
        });
        console.log("[MapCustomControlsService] resetView - Animación iniciada");
    }

    locate() {
        console.log("[MapCustomControlsService] locate - Solicitando ubicación...");
        const map = mapService.get();

        if (!map) {
            console.error("[MapCustomControlsService] locate - No hay mapa disponible");
            return;
        }

        if (!navigator.geolocation) {
            console.error("[MapCustomControlsService] locate - Geolocalización no disponible en este navegador");
            return;
        }

        navigator.geolocation.getCurrentPosition(
            (pos) => {
                console.log("[MapCustomControlsService] locate - Ubicación obtenida:", pos.coords);
                const coords = [pos.coords.longitude, pos.coords.latitude];
                const transformed = fromLonLat(coords);

                map.getView().animate({
                    center: transformed,
                    zoom: 14,
                    duration: 800
                });
                console.log("[MapCustomControlsService] locate - Animación completada");
            },
            (error) => {
                console.error("[MapCustomControlsService] locate - Error obteniendo ubicación:", error.message);
            },
            {
                enableHighAccuracy: true,
                timeout: 10000,
                maximumAge: 0
            }
        );
    }

    toggleFullscreen() {
        if (!document.fullscreenElement) {
            document.documentElement.requestFullscreen();
        } else {
            document.exitFullscreen();
        }
    }
}

export const mapCustomControlsService = new MapCustomControlsService();
